import { useMemo } from 'react';
import { VisitDetail } from '../../visits/entity';
import { OverheadCost } from './components/MonthlyTrendChart';
import { MetricsDateRange } from './entity';
import { useBusinessMetrics } from './useBusinessMetrics';

export const useBusinessMetricsData = (params: {
  visits: VisitDetail[];
  overheadCosts: OverheadCost[];
  dateRange: MetricsDateRange;
}) => {
  const metrics = useBusinessMetrics({
    visits: params.visits,
    overheadCosts: params.overheadCosts,
    dateRange: params.dateRange,
  });

  const formattedMetrics = useMemo(() => {
    return {
      ...metrics,
      summary: {
        isBreakEven: metrics.breakEven.currentProfit >= 0,
        profitStatus: metrics.breakEven.currentProfit >= 0 ? 'profitable' : 'loss',
        totalProfit: metrics.breakEven.currentProfit,
        totalRevenue: metrics.breakEven.currentRevenue,
        totalCosts: metrics.breakEven.fixedCosts + metrics.breakEven.variableCosts,
        topService: metrics.profitPerHour[0],
        worstService: metrics.profitPerHour[metrics.profitPerHour.length - 1],
        loyaltyProgramUsage: metrics.loyaltyPoints.visitsWithPointsRedeemedPercentage,
      },

      insights: {
        needsPriceIncrease: metrics.breakEven.currentProfit < 0,
        recommendedPriceIncrease: metrics.priceIncrease.averagePriceIncrease,
        servicesNeedingAttention: metrics.inefficiencyAnalysis.filter(
          s => s.recommendation === 'inefficient' || s.recommendation === 'very-inefficient',
        ),
        topPerformingServices: metrics.profitPerHour.slice(0, 3),
        lowPerformingServices: metrics.profitPerHour.slice(-3).reverse(),
      },
    };
  }, [metrics, params.visits, params.overheadCosts, params.dateRange]);

  return formattedMetrics;
};
